import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Petition from "./Petition";
import { trackPageView } from "../utils/mixpanel";

function PetitionRoute() {
  useEffect(() => {
    trackPageView("Petition");
  }, []);
  return (
    <div
      className="App"
      style={{
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100vh",
        flex: 1,
        display: "flex",
      }}
    >
      <Header showFullLogo={true} />
      <div style={{ flex: 1, paddingTop: "100px" }}>
        <Petition />
      </div>
      <Footer />
    </div>
  );
}

export default PetitionRoute;
